const FindFFLIconSvg = ({
  width = 20,
  height = 20,
  viewBox = '0 0 20 20',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <mask
        id="mask0_35638_2074"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path
          d="M19.25 19.25V0.75H0.75V19.25H19.25Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
        />
      </mask>
      <g mask="url(#mask0_35638_2074)">
        <path
          d="M17.1164 10.3293C17.0088 9.94101 16.8482 9.49087 16.9732 9.21598C17.1337 8.86294 17.321 8.30874 17.7433 7.95672C17.9272 7.8034 18.0298 7.55977 18.015 7.30978C18.0067 7.17056 18.0268 7.02325 18.1139 6.91202C18.2595 6.72618 18.5056 6.39353 18.6628 6.17954C18.7514 6.05888 18.7606 5.8915 18.6859 5.76033L18.4002 5.25876C18.329 5.13374 18.2037 5.05151 18.0676 5.05299C17.8953 5.05485 17.766 5.18124 17.7328 5.34275C17.6808 5.59545 17.5346 6.08412 17.155 6.32776C16.9443 6.46293 16.7588 6.54393 16.6121 6.59248C16.4161 6.65735 16.2694 6.83063 16.2193 7.04477C16.1694 7.25799 16.0605 7.51326 15.824 7.67702C15.3544 8.00228 14.7504 8.59256 14.482 8.01431C14.2136 7.43606 14.4485 6.85781 13.8222 6.46026C13.1959 6.06271 12.5472 6.6289 12.1446 6.32776C11.874 6.12533 11.5176 5.84675 11.3129 5.6858C11.2079 5.60322 11.0806 5.56117 10.9507 5.56564C10.2067 5.59127 9.37908 5.53709 8.56348 5.44344"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.42114 5.28768C6.05282 5.07421 4.86019 4.79837 4.35507 4.67522C4.22063 4.64246 4.08813 4.73158 4.05281 4.87505C4.00745 5.05906 3.92161 5.26244 3.76796 5.20728C3.61799 5.15342 3.55878 5.00738 3.53577 4.88901C3.51515 4.78305 3.4393 4.69983 3.34109 4.67663C3.33786 4.67585 3.33463 4.67508 3.33143 4.67434C3.14168 4.62938 2.95408 4.75773 2.9109 4.96178L2.60728 6.39672C2.55643 6.63705 2.52728 6.88184 2.52079 7.12821C2.50486 7.73469 2.51198 8.90483 2.74905 9.78673C2.80614 9.99904 2.91426 10.1908 3.06094 10.3454C3.25588 10.5508 3.55447 10.9184 3.71564 11.3809C3.79968 11.6221 3.99309 11.801 4.22572 11.8606C4.48313 11.9265 4.8035 12.0456 5.00938 12.2547C5.34381 12.5943 6.17612 12.7845 6.92058 12.7426C7.21833 12.7258 7.50361 12.881 7.65916 13.155C7.73533 13.2892 7.79816 13.4461 7.81647 13.616C7.86108 14.0293 8.34 13.9978 8.67382 13.8519C8.84291 13.778 9.03645 13.8373 9.14738 13.9934C9.23629 14.1185 9.32287 14.2864 9.35982 14.4954C9.42614 14.8704 9.65212 15.1803 9.99686 15.3156C10.1785 15.3869 10.3714 15.2508 10.3822 15.0429C10.3978 14.7441 10.5029 14.3447 10.9367 14.2424C11.3504 14.145 11.5773 13.9872 11.6951 13.8713C11.8323 13.7364 11.992 13.6314 12.1658 13.5607C12.6581 13.3605 13.5617 13.0873 14.2401 13.4233C14.3526 13.4789 14.4768 13.4998 14.5999 13.4856C14.8264 13.4594 15.1877 13.4611 15.3431 13.7003C15.5385 14.001 15.6642 14.5769 16.197 14.9839C16.3897 15.1312 16.6573 15.081 16.7956 14.8746L16.8682 14.7665C16.9961 14.5757 16.9899 14.3422 16.8651 14.179C16.5909 13.8202 16.1525 13.1719 16.1372 12.6764C16.1247 12.2739 16.4069 11.8865 16.6827 11.5597"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default FindFFLIconSvg;
